// Recovered compiled webpack factory 37099. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      HTTPAccessErrorStatus: function () {
        return r;
      },
      HTTP_ERROR_FALLBACK_ERROR_CODE: function () {
        return a;
      },
      getAccessFallbackErrorTypeByStatus: function () {
        return s;
      },
      getAccessFallbackHTTPStatus: function () {
        return i;
      },
      isHTTPAccessFallbackError: function () {
        return o;
      },
    }));
  let r = { NOT_FOUND: 404, FORBIDDEN: 403, UNAUTHORIZED: 401 },
    n = new Set(Object.values(r)),
    a = "NEXT_HTTP_ERROR_FALLBACK";
  function o(e) {
    if ("object" != typeof e || null === e || !("digest" in e) || "string" != typeof e.digest)
      return !1;
    let [t, r] = e.digest.split(";");
    return t === a && n.has(Number(r));
  }
  function i(e) {
    return Number(e.digest.split(";")[1]);
  }
  function s(e) {
    switch (e) {
      case 401:
        return "unauthorized";
      case 403:
        return "forbidden";
      case 404:
        return "not-found";
      default:
        return;
    }
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
